import { render } from "./CallbackThankYou.vue?vue&type=template&id=082609e5&ts=true"
import script from "./CallbackThankYou.vue?vue&type=script&lang=ts"
export * from "./CallbackThankYou.vue?vue&type=script&lang=ts"

import "./CallbackThankYou.vue?vue&type=style&index=0&id=082609e5&lang=css"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__